import React from 'react';
import { palette } from '../../styles/theme';

export function VectorSVG ({ customStroke = palette.secondary[600] }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.27593 5.29292C6.4634 5.48045 6.56872 5.73476 6.56872 5.99992C6.56872 6.26509 6.4634 6.51939 6.27593 6.70692L1.68293 11.2999C1.49664 11.4825 1.24583 11.5842 0.985 11.5828C0.724171 11.5815 0.4744 11.4773 0.289964 11.2929C0.105528 11.1084 0.00132999 10.8587 1.26439e-05 10.5978C-0.00130471 10.337 0.100365 10.0862 0.282929 9.89992L4.18293 5.99992L0.282929 2.09992C0.100365 1.91363 -0.00130471 1.66282 1.26439e-05 1.40199C0.00132999 1.14116 0.105528 0.891392 0.289964 0.706956C0.4744 0.52252 0.724171 0.418322 0.985 0.417005C1.24583 0.415687 1.49664 0.517357 1.68293 0.699921L6.27593 5.29292Z" fill={customStroke} />
        </svg>
    );
}
